import ng from 'angular';

@Component('ib-MmB-gastronomic-proposal-module', 'ibPreSelectionMain', {
    bindings: {
        currentStep: '<'
    },
    controller: PreSelectionMainComponent,
    controllerAs: 'preSelectionMainCtrl',
    templateUrl: ['MmBAppConstants', function (MmBAppConstants) {
        return MmBAppConstants.templatesRoute + 'ib-pre-selection-main-view.html';
    }]
},
    [], [])
export class PreSelectionMainComponent implements ng.IController {

    constructor() { }

    activate = (): any => {
    };

    $onInit = this.activate();
}
